import TokenContract from './token.js'
export { TokenContract }



// WEBPACK FOOTER //
// ./src/index.js